<template>
  <!-- 侧边栏 -->
  <a-layout-sider v-model:collapsed="collapsed" :collapsedWidth="collapsedWidth" :trigger="null"
                  :width="expandWidth" class="admin-layout-sider" collapsible>

    <!-- 侧边栏菜单 -->
    <slot-menu #menu="menu">
      <div class="admin-sider-menu">
        <side-menu :menu="menu"/>
      </div>
    </slot-menu>

    <!--点解展开、收缩菜单-->
    <div class="collapsed" @click="toggleCollapsed">
      <v-icon v-if="collapsed" icon="MenuUnfoldOutlined"/>
      <v-icon v-else icon="MenuFoldOutlined"/>
    </div>

  </a-layout-sider>
</template>

<script setup>
/**
 * @author 友人a丶
 * 侧边栏菜单组件
 * */


import initialize from "./initialize";

let {
  collapsed,
  collapsedWidth,
  expandWidth,
  toggleCollapsed
} = initialize();


</script>
<style lang="scss" scoped>

.admin-layout-sider {
  position: fixed;
  top: $admin-header-height;
  left: 0;
  z-index: 9;
  height: 100%;

  /* 收缩 */
  :deep(.collapsed .anticon) {
    color: $admin-menu-color !important;
  }

  :deep(.ant-layout-sider-children) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;

    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;

    height: calc(100vh - $admin-header-height);

    background: $admin-sider-bg;
    //box-shadow: $admin-sider-shadow;


    .admin-sider-menu {

      width: 100%;
      height: 100%;
      overflow: auto;
      padding: 4px 8px 4px 12px;

      /*预留滚动条位置，防止发生抖动*/
      overflow-y: scroll;
      overflow-x: hidden;

      /*导入公共的滚动条样式*/
      @include scroll-bar(3px, 3px);


      .ant-menu {
        background: transparent;
        color: $admin-menu-color;
        //margin-top: 15px;

        /* GPU加速动画 */
        -webkit-transform: translateZ(0);
        -moz-transform: translateZ(0);
        -ms-transform: translateZ(0);
        -o-transform: translateZ(0);
        transform: translateZ(0);

        .ant-menu-item {
          /* 定义菜单样式 */
          border-radius: $sidebar-menu-border-radius;

          a {
            font-size: $admin-menu-size;
          }
        }

        .ant-menu-submenu-arrow {
          color: $admin-menu-color;
        }

        .ant-menu-submenu-active {
          color: $admin-menu-color;
        }

        /* 菜单非被选 */
        .ant-menu-item, .ant-menu-submenu-title {

          margin-bottom: 0;

          a {
            color: $admin-menu-color;
          }

          &:hover {

            &, a {
              color: $sidebar-hover-color;
            }

            background-color: $sidebar-hover-bg-color;
          }
        }

        .ant-menu-inline .ant-menu-item:not(:last-child) {
          margin-bottom: 4px;
        }

        .ant-menu-item-selected {

          a {
            color: $sidebar-hover-color;
          }

          &:after {
            display: none;
          }

          .ant-menu-submenu-arrow {
            color: $sidebar-hover-color;
          }

          background-color: $sidebar-hover-bg-color;
        }


        .ant-menu-title-content {
          margin-left: 10px;
        }
      }

      /* 菜单被选时的样式 */
      .ant-menu-submenu-selected {

        color: $admin-menu-color;

        & > .ant-menu-submenu-title {
          .ant-menu-submenu-arrow {
            &::after, &::before {
              color: $admin-menu-color;
            }
          }
        }
      }

      /* 别actice时的样式 */
      .ant-menu-submenu-title {
        &:active {
          background-color: transparent;
        }
      }

      .ant-menu-inline, .ant-menu-vertical {
        border-right: none;
      }
    }


    .collapsed {

      flex-shrink: 0;
      padding: 10px 16px;
      margin: 4px 0;
      //border-top: 1px solid #f0f0f0;

      background: $admin-sider-bg;
      box-shadow: $admin-sider-shadow;

      cursor: pointer;

      &:hover {
        color: $primary-color;
      }
    }
  }
}
</style>
